<template>
    <b-form-select :disabled="disabled" :value="value" :name="name" @change="$emit('input', $event)" :class="{ 'has-selection': this.value }">
        <option value="" selected disabled hidden>{{ placeholder }}</option>
        <option v-for="option in stateOptions" :value="option.value" :key="option.value">{{ option.text }}</option>
    </b-form-select>
</template>

<script>
export default {
    props: {
        value: {
            required: true,
        },
        country: {
            default: 'US',
        },
        placeholder: {
            default: 'State',
        },
        name: {
            default: 'state',
        },
    },
    data() {
        return {
            loadingStates: false,
            stateRequired: true,
            countryStates: null,
        };
    },
    computed: {
        stateOptions() {
            return this.countryStates ? this.countryStates : [];
        },
        disabled() {
            return _.isEmpty(this.stateOptions);
        },
    },
    methods: {
        getStateOptions(country) {
            const _this = this;
            if (country) {
                this.loadingStates = true;

                axios
                    .get('/geocode/states/' + country)
                    .then((response) => {
                        let data = _this.$vueData.getData(response);
                        _this.countryStates = _.map(data, (item) => {
                            return {
                                value: item.abbreviation,
                                text: item.name,
                            };
                        });
                        _this.stateRequired = !!_this.countryStates.length;
                    })
                    .catch(() => {
                        //
                    })
                    .finally(() => {
                        _this.loadingStates = false;
                    });
            }
        },
    },
    watch: {
        country: {
            immediate: true,
            handler(newVal) {
                this.getStateOptions(newVal);
            },
        },
    },
};
</script>

<style scoped>
select {
    color: #cfd0cf;
}

select.has-selection {
    color: #000;
}
</style>
